import { render, staticRenderFns } from "./agendamento-online.vue?vue&type=template&id=4113bf3c"
import script from "./agendamento-online.vue?vue&type=script&lang=js"
export * from "./agendamento-online.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
